import { MapLayer }		from './'

export class MapFilter {
	public text			= ""
	public toggled	= true

	constructor(data: any, toggled?: boolean, private layer?: MapLayer) {
		if (typeof data === 'string') {
			this.text			= data
			this.toggled	= typeof toggled !== 'undefined' ? toggled : this.toggled;
		} else if (typeof data === 'object') {
			this.text			= typeof data.text		=== 'string'	? data.text			: this.text
			this.toggled	= typeof data.toggled	=== 'boolean'	? data.toggled	: this.toggled
		}
	}

	click() {
		this.toggled = !this.toggled

		this.layer.mapService.setFilter()

		this.layer.setFeatures(this.toggled)
	}
}


// WEBPACK FOOTER //
// ./src/app/electraLib/model/map/mapFilter.ts